// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".oec-wrapper__loading[data-v-0c643334]{background:#fff;position:fixed;top:0;right:0;bottom:0;left:0;z-index:10;font-size:4rem;line-height:1}.oec-wrapper__loading .icon[data-v-0c643334]{position:relative;left:-50%;top:-2rem}.oec-wrapper__loading-icon[data-v-0c643334]{color:var(--theme-primary-color);position:absolute;top:50%;left:50%}.oec-wrapper__loading--error .oec-wrapper__loading-icon[data-v-0c643334]{color:var(--theme-negative-background)}", ""]);
// Exports
module.exports = exports;
